import * as React from 'react';
import { Color } from '../styles/colors';
import CSS from 'csstype';
import css from './text.module.css';
import { LabelHTMLAttributes } from 'react';

export type FontTypes =
  | 'display1'
  | 'display2'
  | 'displaySubhead2'
  | 'pHeader'
  | 'pHeadLarge'
  | 'pHeadSmall'
  | 'pEyebrow1'
  | 'pEyebrow2'
  | 'body1'
  | 'body2'
  | 'interface1'
  | 'interface2'
  | 'interface3'
  | 'interfaceDisclaimer'
  | 'list1'
  | 'list2'
  | 'listSub1'
  | 'listSub2'
  | 'linkStyle'
  | 'hint'
  | 'interstate1'
  | 'interstate2'
  | 'interstate3' // These are the new standard types that design team will use going forward
  // we can update names later when we transition fully to interstate
  // and remove the ones up top.
  | 'display1-blinkui'
  | 'display2-blinkui'
  | 'title1-blinkui'
  | 'title2-blinkui'
  | 'title3-blinkui'
  | 'title4-blinkui'
  | 'headline-blinkui'
  | 'body2-blinkui'
  | 'body3-blinkui'
  | 'callout-blinkui'
  | 'caption1-blinkui' // Desktop only classes
  | 'body1-blinkui'
  | 'caption2-blinkui';
type AlignTypes = 'left' | 'center' | 'right';
type TextProps = LabelHTMLAttributes<any> & {
  children?: string | React.ReactNode;
  el?: string;
  type?: FontTypes;
  style?: CSS.Properties<string | number>;
  color?: Color;
  number?: boolean;
  bold?: boolean;
  light?: boolean;
  align?: AlignTypes;
  strike?: boolean;
  className?: string;
  isPii?: boolean;
  qa?: string;
  onClick?: (...args: Array<any>) => any;
  id?: string;
  user1stId?: string;
  // Special Properties for non text elements
  [key: string]: string | number | boolean | React.ReactNode;
};
const classPrefix = 'Text_';

function appendModifier(className: string, modifier: string): string {
  return className + ' ' + css[classPrefix + modifier];
}

function Text({
  color,
  children,
  el = 'span',
  type = 'body1',
  number,
  strike,
  bold,
  light,
  align,
  style,
  className = '',
  isPii = true,
  qa,
  user1stId,
  ...props
}: TextProps): React.ReactElement {
  let textStyle = css[classPrefix + type];
  if (bold) textStyle = appendModifier(textStyle, 'bold');
  if (light) textStyle = appendModifier(textStyle, 'light');
  if (strike) textStyle = appendModifier(textStyle, 'strike');
  if (number) textStyle = appendModifier(textStyle, 'number');
  if (align) textStyle = appendModifier(textStyle, `align-${align}`);
  const combinedCss = className ? [textStyle, className].join(' ') : textStyle;

  const _style = color ? { ...style, color } : style;

  return React.createElement(
    el,
    {
      className: combinedCss,
      style: _style,
      'data-pii': isPii ? '' : null,
      // '' results in blank attribute (what we need)
      id: qa ? qa : '',
      ...props,
      'data-user1st-id': user1stId,
    },
    children
  );
}

export default Text;
